import { createApi } from '@reduxjs/toolkit/query/react';
import { GraphFolderStructure } from '../types/graph';
import { createBaseQuery } from './api/baseApiConfig';
import config from '../config';

const baseUrl = 'graph';

export const TAGS = {
	FOLDER_STRUCTURE: 'FOLDER_STRUCTURE',
};

export const graphApi = createApi({
	reducerPath: 'graphApi',
	baseQuery: createBaseQuery(`${config.APIM_BASE_URL}/${baseUrl}`),
	tagTypes: [TAGS.FOLDER_STRUCTURE],
	endpoints: builder => ({
		getFolderStructure: builder.query<GraphFolderStructure, { customerName: string }>({
			query: ({ customerName }) => ({
				url: `/SearchCustomerFolderStructure`,
				method: 'GET',
				params: {
					customerName,
				},
			}),
			providesTags: [TAGS.FOLDER_STRUCTURE],
		}),
		getAllCustomersStructure: builder.query<GraphFolderStructure, void>({
			query: () => ({
				url: '/GetAllCustomersStructureAsyncFunc',
				method: 'GET',
			}),
			providesTags: [TAGS.FOLDER_STRUCTURE],
		}),
	}),
});

export const { useGetFolderStructureQuery, useGetAllCustomersStructureQuery } = graphApi;
